module.exports = __webpack_public_path__ + "img/no-document.bb6491d9.png";